import classNames from "classnames";
import * as React from "react";
import styles from "./index.module.css";

type Props = {
  className?: string;
};

export const LoadingSpinner: React.FC<Props> = ({ className }) => {
  return (
    <span
      className={classNames(styles.spinner, className)}
      aria-hidden="true"
    />
  );
};
